import { Button, Checkbox, Form, Input, Space } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import EmailIcon from "../../../../assets/icons/EmailIcon";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import InfoItem from "../../../../components/common/InfoItem";
import ConfirmModal from "../../../../components/ui/ConfirmModal";
import Loader from "../../../../components/ui/Loader";
import {
  useGetAllGroupByUserIdQuery,
  useGroupPermissionUpdateMutation,
} from "../../../../features/administrative-setting/administrativeSetting";
import {
  useMakeSuperAdminMutation,
  useRoleStatusQuery,
} from "../../../../features/emp-setting/employee/employeeApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { removeCountryCodeFromNumber } from "../../../../utils/utils";
import EmployeeFileUpload from "../../../admin/Employee/_components/EmployeeFileUpload";
import UserProductManage from "./_components/UserProductManage";

const backLink = "/admin/user-access-permission/user-list";

type TList = {
  productId?: number;
  productName?: string;
  groupId?: number;
  groupName?: string;
  isEdit?: boolean;
};

export default function UserEditPermission() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [list, setList] = useState<TList[]>([]);
  const navigate = useNavigate();
  const [groupPermissionUpdate, { isLoading, isError, error, isSuccess }] =
    useGroupPermissionUpdateMutation();
  useError(isError, error, "Group permission assign fail");
  const { handleOpen, handleClose, open } = useModal<
    boolean | any,
    "CONFIRM_SUPER" | "CONFIRM_CREATE"
  >();
  const [
    makeSuperAdmin,
    {
      isLoading: isSuperAdminLoading,
      isError: isSuperAdminError,
      error: superAdminError,
      isSuccess: isSuperAdminSuccess,
    },
  ] = useMakeSuperAdminMutation();
  useError(isSuperAdminError, superAdminError, "Make super admin fail");
  //   const {
  //     isError: isUserError,
  //     error: userError,
  //     data: useData,
  //     isLoading: isUserLoading,
  //   } = useGetSingleUserQuery(id || "", {
  //     skip: !id,
  //   });
  //   useError(isUserError, userError, "User fetch fail");

  const {
    isError: isRoleError,
    error: roleError,
    isLoading: isRoleLoading,
    data: roleData,
  } = useRoleStatusQuery(String(id), {
    skip: !id,
  });
  useError(isRoleError, roleError, "Get role fail");
  const {
    data: groupData,
    isLoading: isGroupLoading,
    isError: isGroupError,
    error: groupError,
  } = useGetAllGroupByUserIdQuery(
    {
      params: { id: Number(id) },
    },
    {
      skip: !id,
    }
  );
  useError(isGroupError, groupError, "Get group data fail");
  const singleUser = groupData?.data?.user;
  const groupPermissions = groupData?.data?.groupPermissions;

  useEffect(() => {
    if (groupPermissions?.length) {
      const permissionList = groupPermissions?.map((el) => ({
        productId: el?.productId,
        productName: el?.product?.name,
        groupId: el?.id,
        groupName: el?.groupName,
        isEdit: false,
      }));

      setList(permissionList);
    }
  }, [groupPermissions]);

  const onFinish = () => {
    if (!list.length) {
      toast("error", "You must choose at least one role group.");
      return;
    }

    const newValues = {
      groupPermissionIds: list?.map((el) => el?.groupId),
      userId: Number(id),
    };

    handleOpen({ type: "CONFIRM_CREATE", data: newValues });
  };

  useEffect(() => {
    if (!!Object.keys(singleUser || {}).length) {
      form.setFieldsValue({
        username: singleUser?.username,
        email: singleUser?.email,
        mobile_number: singleUser?.mobile
          ? removeCountryCodeFromNumber(singleUser?.mobile)
          : undefined,
        // address:singleUser?.add
        logo: singleUser?.photo,
      });
    }
  }, [form, singleUser]);

  useEffect(() => {
    if (isSuperAdminSuccess) {
      toast(
        "success",
        open?.data
          ? "Successfully make this user a super admin"
          : "Successfully remove super admin status from this user"
      );
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuperAdminSuccess]);

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Group permission updated successfully");
      navigate(backLink);
    }
  }, [isSuccess, navigate]);

  return (
    <SidebarLayout title="Update Permission">
      {open?.type === "CONFIRM_SUPER" && (
        <ConfirmModal
          confirmTitle="Confirm"
          questionText={`Are you sure you want to ${
            open?.data
              ? "make this user a super admin"
              : "remove super admin status from this user"
          }?`}
          okText="Confirm"
          handleClose={handleClose}
          open={open?.open}
          okLoading={isSuperAdminLoading}
          handleOk={() => {
            makeSuperAdmin({
              body: { enable: open?.data },
              id: Number(id),
            });
          }}
        />
      )}

      {open?.type === "CONFIRM_CREATE" && (
        <ConfirmModal
          confirmTitle="Confirm Action"
          questionText={`Are you sure you want to update permission in this user?`}
          okText="Yes, Confirmed"
          handleClose={handleClose}
          open={open?.open}
          okLoading={isLoading}
          handleOk={() => {
            groupPermissionUpdate(open?.data);
          }}
        />
      )}

      {isGroupLoading ? (
        <Loader />
      ) : (
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <CardTitle>User Info</CardTitle>

            <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-x-6 pt-4 mb-6">
              {/* <Form.Item
              label="Select User"
              name="userId"
              rules={[{ required: true, message: "Please select user" }]}
            >
              <Input placeholder="Enter User Name" disabled />
            </Form.Item> */}
              <Form.Item label="User Name" name="username">
                <Input placeholder="Enter User Name" disabled />
              </Form.Item>

              <Form.Item label="Email ID" name="email">
                <Input
                  placeholder="Enter email id"
                  prefix={<EmailIcon />}
                  disabled
                />
              </Form.Item>

              <Form.Item label="Contact No" name="mobile_number">
                <Input prefix={"+88"} size="large" placeholder="01" disabled />
              </Form.Item>

              {/* <Form.Item label="Address" name="address">
              <Input placeholder="Enter  address" disabled />
            </Form.Item> */}

              <Form.Item
                name="logo"
                label="User Photo"
                className="mb-4"
                valuePropName="fileUrl"
              >
                <EmployeeFileUpload
                  form={form}
                  accept=".png, .jpg, .jpeg"
                  name="logo"
                  fileSize={5}
                  onChange={(url) =>
                    form.setFieldsValue({
                      logo: url,
                    })
                  }
                  disabled
                />
              </Form.Item>
            </div>

            <CardTitle>User Role Group</CardTitle>
            <InfoItem rootClassName="!py-3" className="space-x-1">
              <Checkbox
                id="supper_admin"
                checked={roleData?.data?.isSuperAdmin}
                disabled={isRoleLoading || !id}
                onChange={(checked) => {
                  handleOpen({
                    type: "CONFIRM_SUPER",
                    data: checked.target.checked,
                  });
                }}
              />{" "}
              <label
                htmlFor="supper_admin"
                className={`text-accent select-none ${
                  isRoleLoading || !id ? "cursor-not-allowed" : "cursor-pointer"
                }`}
              >
                Assign as Super Admin
              </label>
            </InfoItem>

            <UserProductManage list={list} setList={setList} />

            <Space className="w-full my-4" size={12}>
              <Link to={backLink}>
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                // loading={id ? updateSingleUserIsLoading : isCreateUserLoading}
              >
                {id ? "Update" : "Create user"}
              </Button>
            </Space>
          </CustomCard>
        </Form>
      )}
    </SidebarLayout>
  );
}
